import { NdcMarketing as NdcMarketingType } from '../../types/code.types';

interface NdcMarketingProps {
  marketing: NdcMarketingType | null;
}

const formatDate = (value: string) => new Date(value).toLocaleDateString();

const NdcMarketing = ({ marketing }: NdcMarketingProps) => {
  if (!marketing) return null;
  const pharmClasses = marketing.pharmClass ? marketing.pharmClass.split(';').map((c) => c.trim()).filter(Boolean) : [];
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-4">💊 FDA Marketing Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {marketing.marketingStartDate && (
          <div>
            <p className="text-sm text-gray-500">Marketing Start Date</p>
            <p className="text-gray-800 font-medium">{formatDate(marketing.marketingStartDate)}</p>
          </div>
        )}
        {marketing.marketingEndDate && (
          <div>
            <p className="text-sm text-gray-500">Marketing End Date</p>
            <p className="text-gray-800 font-medium">{formatDate(marketing.marketingEndDate)}</p>
          </div>
        )}
        {marketing.deaSchedule && (
          <div>
            <p className="text-sm text-gray-500">DEA Schedule</p>
            <p className="text-gray-800 font-medium">{marketing.deaSchedule}</p>
          </div>
        )}
        {marketing.listingExpirationDate && (
          <div>
            <p className="text-sm text-gray-500">Listing Expiration Date</p>
            <p className="text-gray-800 font-medium">{formatDate(marketing.listingExpirationDate)}</p>
          </div>
        )}
      </div>
      {pharmClasses.length > 0 && (
        <div className="mt-4">
          <p className="text-sm text-gray-500 mb-2">Pharmacologic Class</p>
          <div className="flex flex-wrap gap-2">
            {pharmClasses.map((cls) => (
              <span key={cls} className="px-3 py-1 bg-primary-50 text-primary-700 rounded-full text-sm">{cls}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NdcMarketing;
